import { render, staticRenderFns } from "./Revenue-history.vue?vue&type=template&id=709cd478"
import script from "./Revenue-history.vue?vue&type=script&lang=js"
export * from "./Revenue-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports